export default __webpack_public_path__ + "static/media/angular.35ac0ba2.png";